import React from 'react';
import CourseHighlights from '../../Shared/Courses/CourseHighlights';
import Blockchain2 from '../../../img/Course-Elements/DS2.png'
import CourseOperate from '../../Shared/Courses/CourseOperate';

const Blockchain = () => {


    return (
        <div className='px-4 md:px-12 pt-10'>
            <h4 className='text-blue-500 text-xl'>Certified Online Course</h4>
            <h1 className='text-blue-500 text-5xl font-semibold my-4'>Block<span className='text-orange-400'>chain</span></h1>
            <h1 className='text-4xl font-semibold my-4'>Course @ Rs. 1199</h1>
            <h2 className=''>Learn how to use the technology that is transforming various sectors, including banking, IoT, and logistics</h2>
            <h3 className='text-xl my-4 font-semibold'>8 Weeks, 45 min /day (3 Recorded+2 Live)</h3>
            <h5>Offer: Get flat Rs.200 off by applying the promo code CAREERHikers</h5>
            <h1 className='text-5xl mt-4 font-bold'>Download the</h1>
            <h1 className='text-5xl mt-2 text-orange-500 font-bold'><span className='text-blue-500'>APP</span> Now!</h1>
            <CourseHighlights />
            <div className='flex mb-8 mt-12'>
                <div className='flex-1 md:mr-4'>
                    <h1 className='text-3xl font-semibold mb-6'>Why Study Blockchain?</h1>
                    <h1 className='text-2xl my-2'>It's upending the entire universe.</h1>
                    <p>This revolutionary technology is upending the banking, internet of things, logistics, and many other sectors of the economy. Avoid falling behind.</p>
                    <h1 className='text-2xl my-2'>Have high demand</h1>
                    <h3>A blockchain engineer can expect to earn an average income of 5.5 LPA+, and businesses are anticipated to invest more than 18 billion dollars in this technology by 2024, making it one of the trendiest employment possibilities.
                    </h3>
                    <h1 className='text-2xl my-2'>Security</h1>
                    <p>Blockchain technology is very safe because it uses a decentralized, cryptographically protected method to store records.</p>
                </div>
                <img className='flex-1' src={Blockchain2} alt="" />
            </div>
            <CourseOperate />
        </div>
    );
};
export default Blockchain;